import { useCallback } from 'react';

import { useCanvas } from '../../../core/components/canvas/hooks/useCanvas.js';
import { getCanvasColor } from '../../../core/components/canvas/utils/canvas-color.js';
import { drawRoundRect } from '../../../core/components/canvas/utils/drawRoundRect.js';
import { buildRgbaColorWithOpacity } from '../../../core/utils/build-rgba-color-with-opacity.js';
import {
  RECT_BORDER_RADIUS,
  RECT_CLUSTER_OPACITY,
  RECT_STROKE_WIDTH,
} from '../../constants.js';

export interface TreeMapClusterBorderProps {
  x: number;
  y: number;
  color: string;
  width: number;
  height: number;
  opacity?: number;
}

export const TreeMapClusterBorder = (props: TreeMapClusterBorderProps) => {
  const { x, y, color, width, height, opacity = 1 } = props;
  const baseColor = getCanvasColor(color);
  const backgroundColor = buildRgbaColorWithOpacity(
    baseColor,
    RECT_CLUSTER_OPACITY,
  );

  const draw = useCallback(
    (ctx: CanvasRenderingContext2D) => {
      ctx.moveTo(x, y);
      ctx.beginPath();

      ctx.strokeStyle = baseColor;
      ctx.filter = 'none';
      ctx.lineWidth = RECT_STROKE_WIDTH;
      ctx.globalAlpha = opacity;
      ctx.fillStyle = backgroundColor;
      drawRoundRect(ctx, x, y, width, height, RECT_BORDER_RADIUS);
      ctx.stroke();
      ctx.fill();

      return false;
    },
    [x, y, baseColor, opacity, backgroundColor, width, height],
  );

  useCanvas('treemap-cluster-border', draw);

  return null;
};
